import React, { useState, useEffect } from "react";

// DIR compliance banner.
//  - On the Texas DIR contract pages it is rendered persistently (no autoHideMs).
//  - On the main landing page it is passed autoHideMs to disappear after a delay.
const DirDisclaimer = ({ autoHideMs }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!autoHideMs) return undefined;
    const timer = setTimeout(() => setVisible(false), autoHideMs);
    return () => clearTimeout(timer);
  }, [autoHideMs]);

  if (!visible) return null;

  return (
    <div id="dir-disclaimer">
      <div className="dir-disclaimer-inner">
        <span className="dir-disclaimer-icon">&#9432;</span>
        <p>
          <strong>PLEASE NOTE:</strong> NAVIGATION FROM THIS PAGE DOES NOT REPRESENT TEXAS DIR CONTRACT OFFERINGS.
        </p>
      </div>
    </div>
  );
};

export default DirDisclaimer;
